/**
 * /forgot-password — public route. SPEC-01 §3.7, Stage 2.
 *
 * WHY THIS PAGE EXISTS. Until today an invited person had a one-way door: the
 * gateway has carried `POST /api/auth/forgot-password` and
 * `POST /api/auth/reset-password` since 0163, `lib/public-paths.ts` has listed
 * both pages as public, and there was no screen for either. The sign-in card
 * said "Contact your CHAOS admin to reset it" to people who have never been
 * told who that is. Founder decision, 2026-08-06: build it.
 *
 * ─── NO `beforeLoad` REDIRECT, AND THAT IS DELIBERATE ─────────────────────
 *
 * /login bounces an already-authenticated visitor to /boards, because standing
 * on a sign-in form with a live session is nonsense. This page is not that.
 * Somebody who is signed in and asks for a reset link is the person who
 * believes their password is compromised — the exact case the feature exists
 * for — and bouncing them to /boards would take the recovery door away from
 * the one person who is trying to use it deliberately.
 *
 * Nothing here needs a guard in the other direction either: `/forgot-password`
 * is already in `PUBLIC_PATHS`, so the module-scope subscription in
 * `_authenticated.tsx` leaves an unauthenticated visitor where they are
 * instead of throwing them onto /login (the 2026-08-05 P0; see
 * `lib/public-paths.ts` and `tests/unit/invitation-path-not-evicted.test.ts`).
 *
 * There is no `validateSearch`: this page takes nothing from the URL. The
 * screen itself is in ./forgot-password.lazy.tsx, split out like every other
 * route in this folder.
 */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/forgot-password')({}).lazy(() =>
  import('./forgot-password.lazy').then((d) => d.Route),
);
